/**
 * The conservative subset the picker offers before the server answers.
 *
 * This file used to mirror the backend's whole allow-list by hand, with a
 * comment calling the mirroring "a maintenance cost worth paying". That was
 * true for seven extensions. It stopped being true at twenty-plus, where the
 * mirror is guaranteed to drift and the drift is invisible until a user is
 * told their file is unsupported by a picker whose server would have taken it.
 *
 * So the real list now comes from `/media/capabilities` via
 * `useMediaCapabilities`, and what remains here is the **first-paint
 * fallback**: a file input needs an `accept` attribute before any request can
 * complete, and an empty one means "any file". These are deliberately the
 * formats that have always worked, so the worst case for a few hundred
 * milliseconds is a picker that is too strict - never one that promises more
 * than the server delivers.
 *
 * **Not a security boundary**, and never was. Anything here is bypassable with
 * the developer tools open; the backend re-derives the extension, sniffs the
 * container and decodes the file.
 */

export const FALLBACK_PHOTO_EXTENSIONS = ["jpg", "jpeg", "png", "webp"] as const;
export const FALLBACK_VIDEO_EXTENSIONS = ["mp4", "mov", "m4v", "webm"] as const;

export function extensionOf(filename: string): string {
  const dot = filename.lastIndexOf(".");
  return dot === -1 ? "" : filename.slice(dot + 1).toLowerCase();
}
